import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RiderCreateModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      errorMessage: ''
    }

    this.input = React.createRef()
  }

  componentDidMount() {
    this.input.current.focus()
  }

  addNewRider = (e) => {
    e.preventDefault()

    const { title } = this.state

    if (!title) {
      this.setState({errorMessage: "Please insert title"})
    } else {
      this.props.createRider(this.state.title)
      this.props.setModal(false)
    }
  }

  render() {
    return (
      <div className="modal-content">
        <form onSubmit={this.addNewRider}>
          <ul className="group" data-error-msg={this.state.errorMessage}>
            <h4>Create new rider</h4>

            <li data-title="Rider's title">
              <input ref={this.input}
                type="text"
                className="input--light"
                value={this.state.title}
                onChange={(e) => this.setState({title: e.target.value})} />
            </li>
          </ul>

          <button type="submit" className="button--success">Create rider</button>
        </form>
      </div>
    )
  }
}

RiderCreateModal.propTypes = {
  setModal: PropTypes.func
}

RiderCreateModal.defaultProps = {
  setModal: function() {}
}

export default RiderCreateModal



// WEBPACK FOOTER //
// ./src/components/modals/rider-create-modal.js